import { createTheme } from '@mui/material/styles';

export const commonFont = {
    regular: '"SF-UI-Display-Regular"',
    medium: '"SF-UI-Display-Medium"',
    black: '"SF-UI-Display-Black"',
    bold: '"SF-UI-Display-Bold"',
    light: '"SF-UI-Display-Light"'
}
const theme = createTheme({
    palette:{
        common:{
            white:"#ffffff",
            black:"#212121",
            green: '#008000',
            red: '#ff0000'
        },
        primary:{
            main: '#00688F',
            light:'rgb(0, 91, 167,0.7)',
            dark: '#0C475D',
        },
        secondary:{
            main: '#00E1FF',
            light:'#E80E45',
            dark: '#E80E45',
        },
        text:{
            primary:"#212121",
            secondary:"rgb(33, 33, 33,0.6)",
            disabled:"#8B8B8B",
            onPrimary: "#ffffff",
            success: '#388E3C',
            note: '#808080',
            link: '#337ab7',
        },
        background:{
            paper:"#f3f3f4",
            default:"#ffffff",
            secondary: "#F1F1F1",
            primary: '#ccc',
            other: '#005BA71F',
            success: '#388E3C',
            disabled: '#E9E9E9',
            card: '#eee',
        },
        border:{
            main:"rgb(255, 255, 255,0.4)",
            primary:"#FFFFFF99",
            light: '#cdcdcd',
            secondary: '#eee',
            input: '#C4C4C4',
        },
        shadow: {
            main: '#0000000D',
        }
    },
    typography: {
        h1: {
            fontSize: 30,
            fontWeight: 200
        },
        h2: {
            fontFamily: commonFont.medium,
        },
        h3: {
            fontFamily: commonFont.bold,
        },
        h4: {
            fontFamily: commonFont.medium,
        },
        h5: {
            fontFamily: commonFont.medium,
        },
        h6: {
            fontFamily: commonFont.bold,
        },
        subtitle1: {
            fontFamily: commonFont.regular,
        },
        subtitle2: {
            fontFamily: commonFont.medium,
        },
        body1: {
            fontSize: 14,
            fontFamily: commonFont.regular,
        },
        body2: {
            fontSize: 14,
            fontFamily: commonFont.bold,
        },
        button: {
            fontFamily: commonFont.bold,
        },
        caption: {
            fontFamily: commonFont.medium,
        },
        overline: {
            fontFamily: commonFont.regular,
        },
        p: {
            fontSize: 13
        },
        normal: {
            fontSize: 14,
            fontFamily: commonFont.regular,
        },
        headBold: {
            fontSize: 14,
        }
    },
});

export default theme;